import "./PolicyBulkEditor.css";
import { useState } from "react";
import { Save, X } from "lucide-react";
import { POLICY_EDITOR_SECTIONS, PolicyFieldInput } from "./PolicyEditor";

export function PolicyBulkEditor({ count, options, onClose, onSave }) {
  const [updates, setUpdates] = useState({});
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const metadata = Object.fromEntries((options.field_meta || []).map((item) => [item.key, item]));
  const fieldCount = Object.keys(updates).length;
  const toggle = (key, checked) => setUpdates((current) => {
    const next = {...current};
    if (checked) next[key] = "";
    else delete next[key];
    return next;
  });
  const submit = async () => {
    setBusy(true); setError("");
    try { await onSave(updates, reason, count); onClose(); }
    catch (problem) { setError(problem.response?.data?.detail || "Toplu düzenleme tamamlanamadı."); }
    finally { setBusy(false); }
  };
  return <div className="modal-backdrop" data-testid="policy-bulk-edit-modal">
    <div className="modal policy-editor-modal" role="dialog" aria-modal="true" aria-labelledby="policy-bulk-edit-title">
      <div className="modal-head"><div className="policy-bulk-heading"><span className="eyebrow">TOPLU DÜZENLEME</span><strong id="policy-bulk-edit-title">{count.toLocaleString("tr-TR")} poliçeyi düzenle</strong></div><button className="icon-button" aria-label="Kapat" disabled={busy} onClick={onClose}><X size={16}/></button></div>
      <div className="policy-editor-content">
        <p className="policy-bulk-edit-help">Değiştirmek istediğiniz alanları işaretleyin. Girdiğiniz değer seçili poliçelerin tamamına uygulanır; işaretlenmeyen alanlar korunur. İşaretli bir metin alanını boş bırakmak o alanı temizler. Bir işlemde en fazla 1.000 kayıt düzenlenebilir.</p>
        {POLICY_EDITOR_SECTIONS.map(([title, fields]) => <section key={title} className="policy-editor-section"><h3>{title}</h3><div className="policy-editor-grid">
          {fields.filter((key) => metadata[key]).map((key) => {
            const checked = Object.prototype.hasOwnProperty.call(updates, key);
            return <div key={key} className={`policy-bulk-edit-field ${checked ? "enabled" : ""}`}>
              <label className="policy-bulk-edit-toggle"><input type="checkbox" data-testid={`policy-bulk-enable-${key}`} checked={checked} disabled={busy} onChange={(event) => toggle(key, event.target.checked)}/><span>{metadata[key].label} · Değiştir</span></label>
              <PolicyFieldInput meta={metadata[key]} options={options} value={updates[key]} disabled={busy || !checked} testPrefix="policy-bulk-field" onChange={(value) => setUpdates((current) => ({...current, [key]:value}))}/>
            </div>;
          })}
        </div></section>)}
        <section className="policy-editor-reason"><label>Değişiklik nedeni <span>Her poliçenin tarihçesine kaydedilir</span><textarea data-testid="policy-bulk-edit-reason" rows={3} value={reason} disabled={busy} onChange={(event) => setReason(event.target.value)}/></label></section>
        {error && <div role="alert" className="error" data-testid="policy-bulk-edit-error">{error}</div>}
      </div>
      <div className="modal-foot"><span>{fieldCount} alan · {count.toLocaleString("tr-TR")} kayıt</span><button className="outline-button" disabled={busy} onClick={onClose}>İptal</button><button className="primary-button" data-testid="policy-bulk-edit-submit" disabled={busy || !fieldCount || reason.trim().length < 3 || count > 1000} onClick={submit}><Save size={14}/>{busy ? "Kaydediliyor ve hesaplanıyor..." : "Seçili poliçelere uygula"}</button></div>
    </div>
  </div>;
}
